"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _axios = _interopRequireDefault(require("axios"));
var _basic = _interopRequireDefault(require("./_basic"));
var _bluebird = _interopRequireDefault(require("bluebird"));
var _roles = _interopRequireDefault(require("./types/roles"));
class SettingsApi extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      sdkApiUrl
    } = _ref;
    super({
      userTokenFactory
    });
    this.sdkApiUrl = sdkApiUrl;
  }
  accountSettingsUrl(_ref2) {
    let {
      accountId,
      key
    } = _ref2;
    if (accountId && key) {
      return `${this.sdkApiUrl}/accounts/${accountId}/account-settings/${key}`;
    } else if (accountId) {
      return `${this.sdkApiUrl}/accounts/${accountId}/account-settings`;
    } else if (key) {
      return `${this.sdkApiUrl}/account-settings/${key}`;
    }
    return `${this.sdkApiUrl}/account-settings`;
  }
  userSettingsUrl(_ref3) {
    let {
      accountId,
      userId,
      key
    } = _ref3;
    if (accountId && userId && key) {
      return `${this.sdkApiUrl}/accounts/${accountId}/users/${userId}/user-settings/${key}`;
    } else if (accountId && userId) {
      return `${this.sdkApiUrl}/accounts/${accountId}/users/${userId}/user-settings`;
    } else if (userId && key) {
      return `${this.sdkApiUrl}/users/${userId}/user-settings/${key}`;
    } else if (userId) {
      return `${this.sdkApiUrl}/users/${userId}/user-settings`;
    } else if (key) {
      return `${this.sdkApiUrl}/user-settings/${key}`;
    }
    return `${this.sdkApiUrl}/user-settings`;
  }
  mergedSettingsUrl(_ref4) {
    let {
      accountId,
      userId,
      key
    } = _ref4;
    if (accountId && userId && key) {
      return `${this.sdkApiUrl}/accounts/${accountId}/users/${userId}/settings/${key}`;
    } else if (accountId && userId) {
      return `${this.sdkApiUrl}/accounts/${accountId}/users/${userId}/settings`;
    } else if (userId && key) {
      return `${this.sdkApiUrl}/users/${userId}/settings/${key}`;
    } else if (userId) {
      return `${this.sdkApiUrl}/users/${userId}/settings`;
    } else if (key) {
      return `${this.sdkApiUrl}/settings/${key}`;
    }
    return `${this.sdkApiUrl}/settings`;
  }
  getRoleSettings(role, payload) {
    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }
    switch (role) {
      case _roles.default.SUPER_ADMIN:
      case _roles.default.ADMIN:
        return this.getAccountSettings(payload, ...rest);
      case _roles.default.USER:
      case _roles.default.GUEST:
        return this.getUserSettings(payload, ...rest);
      default:
        return _bluebird.default.reject('Role is not valid');
    }
  }
  setRoleSettings(role, payload) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      rest[_key2 - 2] = arguments[_key2];
    }
    switch (role) {
      case _roles.default.SUPER_ADMIN:
      case _roles.default.ADMIN:
        return this.setAccountSettings(payload, ...rest);
      case _roles.default.USER:
      case _roles.default.GUEST:
        return this.setUserSettings(payload, ...rest);
      default:
        return _bluebird.default.reject('Role is not valid');
    }
  }
  async getAccountSettings(_ref5) {
    let {
      accountId,
      key
    } = _ref5;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(this.accountSettingsUrl({
      accountId,
      key
    }), headers)).then(response => _bluebird.default.resolve(response.data)).then(data => key ? _lodash.default.get(data, 'value') : data);
  }
  async getUserSettings(_ref6) {
    let {
      accountId,
      userId,
      key
    } = _ref6;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(this.userSettingsUrl({
      accountId,
      userId,
      key
    }), headers)).then(response => _bluebird.default.resolve(response.data)).then(data => key ? _lodash.default.get(data, 'value') : data);
  }
  async getMergedSettings(_ref7) {
    let {
      accountId,
      userId,
      key
    } = _ref7;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(this.mergedSettingsUrl({
      accountId,
      userId,
      key
    }), headers)).then(response => _bluebird.default.resolve(response.data)).then(data => key ? _lodash.default.get(data, 'value') : data);
  }
  async setAccountSettings(_ref8) {
    let {
      accountId,
      key,
      value
    } = _ref8;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.post(this.accountSettingsUrl({
      accountId,
      key
    }), value, headers)).then(response => _bluebird.default.resolve(response.data)).then(data => key ? _lodash.default.get(data, 'value') : data);
  }
  async setUserSettings(_ref9) {
    let {
      accountId,
      userId,
      key,
      value
    } = _ref9;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.post(this.userSettingsUrl({
      accountId,
      userId,
      key
    }), value, headers)).then(response => _bluebird.default.resolve(response.data)).then(data => key ? _lodash.default.get(data, 'value') : data);
  }
  async deleteAccountSettings(_ref10) {
    let {
      accountId,
      key
    } = _ref10;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.delete(this.accountSettingsUrl({
      accountId,
      key
    }), headers)).then(response => _bluebird.default.resolve(response.data));
  }
  async deleteUserSettings(_ref11) {
    let {
      accountId,
      userId,
      key
    } = _ref11;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.delete(this.accountSettingsUrl({
      accountId,
      userId,
      key
    }), headers)).then(response => _bluebird.default.resolve(response.data));
  }
}
var _default = SettingsApi;
exports.default = _default;